"use strict";
import "src/decidim/decidim_awesome/proposals/custom_fields";
